import axios from "axios";

import { BeneficiaryPreCadastro, ResponseGetBenefiaryByCPF } from "../TypesOrInterfaces/induction";
import { api } from "./api";

export interface BeneficiaryPreCadastroLookupResult {
    data: BeneficiaryPreCadastro | null;
    status: number;
    errorCode?: number;
    message?: string;
}

export async function getBeneficiaryPreCadastro(
    token: string,
    cpf: string,
    quizId: number
): Promise<BeneficiaryPreCadastroLookupResult> {
    if (!token || !cpf || !quizId) {
        return {
            data: null,
            status: 400,
            message: "Parâmetros inválidos para consultar o pré-cadastro."
        };
    }

    try {
        const response = await api.get<ResponseGetBenefiaryByCPF>(
            "/Beneficiary/api/v1/BeneficiaryPreCadastro/GetByCpfQuiz",
            {
                headers: {
                    cpf,
                    codQuiz: quizId,
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return {
            data: response.data.data ?? null,
            status: response.status,
            errorCode: response.data.error?.code,
            message: response.data.error?.message
        };
    } catch (error) {
        if (axios.isAxiosError(error)) {
            const responseData = error.response?.data as any;

            return {
                data: null,
                status: error.response?.status ?? 500,
                errorCode: responseData?.error?.code,
                message:
                    responseData?.messages?.[0]?.message ||
                    responseData?.error?.message ||
                    error.message
            };
        }

        return {
            data: null,
            status: 500,
            message: "Ocorreu um erro ao consultar o pré-cadastro."
        };
    }
}
